<template>
    <div class="layout">
        <LayoutHeader ref="header" />
        <div class="layout-content" :class="{ isSHow }">
            <router-view />
        </div>
        <LayoutFooter v-if="isSHow" />
    </div>

</template>

<script>
import LayoutHeader from './header.vue'
import LayoutFooter from './footer.vue'
import { Overlay, Popup, Loading } from 'vant';
export default {
    name: 'layout',
    components: {
        LayoutHeader,
        Popup,
        LayoutFooter,
        Loading
    },
    computed: {
        isSHow() {
            return ['home',
                'mining',
                'wallet',
                'me'].includes(this.$route.name)
        }
    },
    methods: {
        handleClick() {
        },
        handleClose() {
        }
    }
}
</script>

<style lang="less">
.layout {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 375px;
    background: url('../assets/img/layout/bg.png') no-repeat;
    background-size: 100% 100%;
    padding-bottom: 80px;

    .layout-content {
        flex: 1;
        display: flex;
        flex-direction: column;
   

        &.isSHow {
            padding-bottom: 82px;

        }
    }
}


</style>